namespace Solovis.Async {

    export async function delay(delayMilliseconds): Promise<any> {
        let promise = new Promise(function (resolve, reject) {
            setTimeout(function () {
                resolve(undefined);
            }, delayMilliseconds);              
        });

        return promise;        
    }

}